import { createContext, useContext, useEffect, useState } from "react";
import { api, DEFAULT_SETTINGS } from "@/lib/api";

const SettingsContext = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data })).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
